// CardLiberar.jsx
import React, { useState, useEffect } from 'react';
import { Button } from "primereact/button";
import { useHistory } from 'react-router-dom';
import useGetData from "../../../../repo/get";

import CodeUnique from "./CodeUnique";

const CardLiberar = () => {
  const [error, setError] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false); // flag para refrescar os códigos
  const history = useHistory();

  const { data, loading, error: fetchError } = useGetData("api/motoristas/findAll");

  useEffect(() => {
    if (fetchError) {
      setError("Erro ao carregar os dados.");
    }
  }, [fetchError]);

  if (error) {
    return <p>{error}</p>;
  }
  if (loading) {
    return <p>Carregando...</p>;
  }

  const deliverers = Array.isArray(data) ? data : [];

  // Função que gera o código único para um motorista.
  const handleGenerate = async (id) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await fetch(`https://api.lc-transportes.com/api/unique/generate/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        alert("Erro ao gerar código");
        return;
      }
      setRefreshFlag((prev) => !prev);
    } catch (error) {
      console.error("Erro ao gerar código:", error);
      alert("Erro ao gerar código");
    }
      history.go(0);
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      <div className="p-6 pb-0 mb-0 border-b-0 border-b-solid rounded-t-2xl border-b-transparent">
        <h1 className="text-2xl font-bold text-blueGray-700">Lista de Códigos de Liberação de Pontos para Motoristas</h1>
      </div>
      <div className="flex-auto px-0 pt-0 pb-2">
        <div className="p-0 overflow-x-auto">
          <table className="items-center w-full mb-0 align-top border-collapse dark:border-white/40 text-slate-500">
            <thead className="align-bottom">
              <tr>
                <th className="px-6 py-3 font-bold text-left uppercase align-middle bg-transparent border-b border-collapse shadow-none dark:border-white/40 dark:text-white text-xxs border-b-solid tracking-none whitespace-nowrap text-slate-400 opacity-70">
                  Funcionário
                </th>
                <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-collapse shadow-none dark:border-white/40 dark:text-white text-xxs border-b-solid tracking-none whitespace-nowrap text-slate-400 opacity-70">
                  Função
                </th>
                <th className="px-6 py-3 pl-2 font-bold text-left uppercase align-middle bg-transparent border-b border-collapse shadow-none dark:border-white/40 dark:text-white text-xxs border-b-solid tracking-none whitespace-nowrap text-slate-400 opacity-70">
                  Código
                </th>
                <th className="px-6 text-right py-3 font-semibold uppercase align-middle bg-transparent border-b border-collapse border-solid shadow-none dark:border-white/40 dark:text-white tracking-none whitespace-nowrap text-slate-400 opacity-70">
                  {/* Coluna para o botão */}
                </th>
              </tr>
            </thead>
            <tbody>
              {deliverers.length > 0 ? (
                deliverers
                  .sort((a, b) => a.nome.localeCompare(b.nome))
                  .map((deliverer) => (
                    <tr key={deliverer.id}>
                      <td className="p-2 align-middle bg-transparent border-b dark:border-white/40 whitespace-nowrap shadow-transparent">
                        <div className="flex px-2 py-1">
                          <div className="mr-2 flex h-8 w-8 items-center justify-center rounded-lg bg-center stroke-0 text-center xl:p-2.5">
                            <i className="relative top-0 text-sm leading-normal text-slate-700 ni ni-single-02"></i>
                          </div>
                          <div className="flex flex-col justify-center">
                            <h6 className="mb-0 text-sm leading-normal dark:text-white font-semibold">
                              {deliverer.nome}
                            </h6>
                            <p className="mb-0 text-xs leading-tight dark:text-white dark:opacity-80 text-slate-400">
                              {deliverer.telefone
                                ? deliverer.telefone.replace(
                                    /(\d{2})(\d{5})(\d{4})/,
                                    "($1) $2-$3"
                                  )
                                : "Localização desconhecida"}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="p-2 align-middle bg-transparent border-b dark:border-white/40 whitespace-nowrap shadow-transparent">
                        <p className="mb-0 text-xs font-semibold leading-tight dark:text-white dark:opacity-80">
                          Motorista
                        </p>
                        <p className="mb-0 text-xs leading-tight dark:text-white dark:opacity-80 text-slate-400">
                          {deliverer.base?.[0]?.nome || "Localização desconhecida"}
                        </p>
                      </td>

                      <td className="p-2 align-middle bg-transparent border-b dark:border-white/40 whitespace-nowrap shadow-transparent">
                        {/* Passa a flag de refresh para que o CodeUnique refaça a requisição */}
                        <CodeUnique id={deliverer.id} refreshFlag={refreshFlag}/>
                      </td>
                      <td className="p-2 align-middle bg-transparent border-b dark:border-white/40 whitespace-nowrap shadow-transparent text-right">
                        <form action="" method="post" onSubmit={(e) => e.preventDefault()}>
                          <input type="hidden" name="uid" value={deliverer.id} />
                          <Button
                            label="Gerar"
                            type="button" // mudamos para button para evitar o comportamento default de submit
                            onClick={() => handleGenerate(deliverer.id)}
                            className="bg-lightBlue-600 text-white px-3 py-1 rounded-md shadow hover:bg-lightBlue-500"
                          />
                        </form>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    Nenhum entregador encontrado
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CardLiberar;
